<template>
  <a-config-provider :get-popup-container="getPopupContainer">
    <a-locale-provider :locale="locale">
      <div id="app">
        <router-view />
      </div>
    </a-locale-provider>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
let element=document.getElementById('layoutContent');
export default {
  data() {
    return {
      locale: zhCN,
    };
  },
  methods: {
    getPopupContainer(el, dialogContext) {
      if (dialogContext) {
        return dialogContext.getDialogWrap();
      } else {
        return document.getElementById('layoutContent');
      }
    },
  },
};
</script>
<style>
html,body{
  background: #f0f2f5;
}
</style>
